import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["code", "className"];
import React from 'react';
import classNames from 'classnames/bind';
import { isString } from "../utils/type";
import styles from './FlagIcon.css';
var cx = classNames.bind(styles);

var FlagIcon = function FlagIcon(_ref) {
  var code = _ref.code,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("span", _extends({}, props, {
    className: cx('fflag', 'custom_size', "fflag-".concat(isString(code) ? code.toUpperCase() : null), className)
  }));
};

export default FlagIcon;